import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const login = () => import("@/views/login/login");
export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login,
    },
  ],
  mode:"history"
})



// WEBPACK FOOTER //
// ./src/router/index.js